'use strict';

const libPictView = require('pict-view');

/**
 * SampleListColumnsConfig view — the shell for the bespoke #/SampleListColumnsConfig screen. A thin host: paints
 * the header + a single #SLC-Detail mount and hands rendering to the SampleListColumnsConfig provider (which
 * self-loads on first render, mirroring ATMDashboardConfig / Certifications).
 */
class SampleListColumnsConfig extends libPictView
{
	get provider() { return this.pict.providers.SampleListColumnsConfig; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SampleListColumnsConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'SampleListColumnsConfig',
	DefaultRenderable: 'SampleListColumnsConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.slc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.slc-head { margin: 0 0 1rem; }
		.slc-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.slc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.slc-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:20rem; }
		.slc-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:14rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
		.slc-scopebar { display:flex; align-items:center; gap:0.4rem; margin:0 0 1rem; }
		.slc-scope-label { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin-right:0.3rem; }
		.slc-scope-btn { font-size:0.84rem; font-weight:600; padding:0.35rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.slc-scope-btn.is-active { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.slc-scope-btn[disabled] { opacity:0.5; cursor:default; }
		.slc-area-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0 0 0.35rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:1.1rem 0 0.6rem; }
		.slc-area-head:first-of-type { margin-top:0; }
		.slc-hint { font-weight:500; text-transform:none; letter-spacing:normal; color:var(--theme-color-text-muted,#8894a4); }
		.slc-cols { display:flex; flex-direction:column; }
		.slc-colhead { display:flex; align-items:center; gap:0.6rem; padding:0 0.2rem 0.3rem; font-size:0.64rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); }
		.slc-ch-order { flex:0 0 3rem; }
		.slc-ch-key { flex:0 0 13rem; }
		.slc-ch-label { flex:1 1 auto; }
		.slc-ch-search { flex:0 0 2rem; text-align:center; }
		.slc-ch-actions { flex:0 0 4rem; }
		.slc-col { display:flex; align-items:center; gap:0.6rem; padding:0.35rem 0.2rem; border-bottom:1px solid var(--theme-color-border-light,#f2f4f8); }
		.slc-order { flex:0 0 3rem; display:flex; gap:0.15rem; }
		.slc-mv { width:1.4rem; height:1.4rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:5px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.66rem; padding:0; }
		.slc-mv:hover { color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-secondary,#eef1f6); }
		.slc-key { flex:0 0 13rem; font-size:0.86rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.slc-label { flex:1 1 auto; min-width:0; font-size:0.86rem; padding:0.32rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.slc-search-btn { flex:0 0 auto; width:1.9rem; height:1.9rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; }
		.slc-search-btn.is-on { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.slc-col-actions { flex:0 0 auto; display:flex; gap:0.25rem; }
		.slc-tmpl-btn, .slc-remove { width:1.9rem; height:1.9rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; }
		.slc-tmpl-btn.is-set { color:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); }
		.slc-remove:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.slc-tmpl-row { display:flex; align-items:center; gap:0.6rem; padding:0.15rem 0.2rem 0.6rem 3.6rem; flex-wrap:wrap; }
		.slc-tmpl-input { flex:1 1 22rem; font-size:0.82rem; padding:0.32rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.slc-tmpl-hint { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); }
		.slc-tmpl-hint code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.slc-availwrap { display:flex; flex-wrap:wrap; gap:0.4rem; }
		.slc-avail { font-size:0.8rem; padding:0.28rem 0.6rem; border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:999px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.slc-avail:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.slc-avail.is-system { opacity:0.55; }
		.slc-avail-empty { font-size:0.84rem; color:var(--theme-color-text-muted,#8894a4); }
		.slc-savebar { margin-top:1.2rem; display:flex; gap:0.6rem; align-items:center; }
		.slc-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
		.slc-save[disabled] { opacity:0.6; cursor:default; }
		.slc-preview { font-size:0.88rem; font-weight:600; padding:0.5rem 1rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.slc-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.slc-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
	`,
	Templates:
	[
		{
			Hash: 'SampleListColumnsConfig-Wrap',
			Template: /*html*/`
				<div class="slc-wrap">
					<div class="slc-head">
						<h1 class="slc-title">Samples List — Columns</h1>
						<p class="slc-subtitle">Choose which columns the Samples list shows, rename their headers, reorder them, and pick which are searchable. Save as a platform default, a customer-wide default, or your own preference.</p>
					</div>
					<div id="SLC-Detail" class="slc-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleListColumnsConfigWrap',
			TemplateHash: 'SampleListColumnsConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
